module.exports = __webpack_public_path__ + "static/media/leftcr8.63648f11.png";